export const paths = {
  // ROTAS PUBLICAS
  login: '/login',
  // ROTAS PRIVADAS
  home: '/home',
  buscarAluno: '/buscar-aluno',
  agendaAulasPraticas: '/agenda-aulas-praticas',
  examesPraticos: '/exames-praticos',
  recibos: '/recibos',
  bancoDigital: '/banco-digital',
  despesasReceitas: '/despesas-receitas',
  despesas: '/despesas',
  matriculas: '/matriculas',
  marketing: '/marketing',
  protocolosProdesp: '/protocolos-prodesp',
};
